import { EMoments } from "../features/shared/enums/EMoments";

export const moments = [
    { label: EMoments.MATIN, value: EMoments.MATIN },
    { label: EMoments.APRES_MIDI, value: EMoments.APRES_MIDI },
    { label: EMoments.SOIR, value: EMoments.SOIR },
    { label: EMoments.NUIT, value: EMoments.NUIT }
];